import React from "react";
import { FileText } from "lucide-react";
import DocumentCard from "./DocumentCard";
import { DocumentRecord } from "./documentTypes";

interface Props {
  documents: DocumentRecord[];
  loading: boolean;
  canDelete: boolean;
  onDelete: (document: DocumentRecord) => void;
  onTogglePin: (document: DocumentRecord) => void;
}

export default function DocumentsList({ documents, loading, canDelete, onDelete, onTogglePin }: Props) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="h-72 animate-pulse rounded-xl border border-slate-800 bg-slate-900/70" />
        ))}
      </div>
    );
  }

  if (!documents.length) {
    return (
      <div className="flex min-h-[320px] flex-col items-center justify-center rounded-xl border border-dashed border-slate-700 bg-slate-900/40 p-6 text-center">
        <FileText size={42} className="text-slate-500" />
        <h3 className="mt-4 text-lg font-bold text-white">No documents found</h3>
        <p className="mt-2 max-w-md text-sm text-slate-400">
          Try changing the search keywords or filters, or upload a new knowledge base document.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {documents.map((document) => (
        <DocumentCard
          key={document.id}
          document={document}
          canDelete={canDelete}
          onDelete={onDelete}
          onTogglePin={onTogglePin}
        />
      ))}
    </div>
  );
}
